var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://www.pausentaste.de/","target":"_blank"}},[_c('Logo')],1)}
var staticRenderFns = []

export { render, staticRenderFns }